import { type RouteLocationNormalized } from 'vue-router';

export const PERFORMANCE_DASHBOARD_ROUTE_NAME = 'performance-dashboard';
export const CONNECT_CONSENT_ROUTE_NAME = 'connect-consent';

interface ShouldStripQueryOptions {
  hasJobsQueryParams: boolean;
  isValidCopilotActivationRoute: boolean;
}

export function shouldStripQuery(
  to: Pick<RouteLocationNormalized, 'path' | 'name' | 'query'>,
  from: Pick<RouteLocationNormalized, 'path'>,
  { hasJobsQueryParams, isValidCopilotActivationRoute }: ShouldStripQueryOptions,
): boolean {
  // The dashboard syncs its tab and filters into the query string, so never strip it.
  const isPerformanceDashboardRoute = to.name === PERFORMANCE_DASHBOARD_ROUTE_NAME;
  // The consent page is reached by a redirect carrying the interaction id, and the first navigation
  // comes from the router's start location, so the path always differs.
  const isConnectConsentRoute = to.name === CONNECT_CONSENT_ROUTE_NAME;

  return (
    to.path !== from.path &&
    Object.keys(to.query).length > 0 &&
    !hasJobsQueryParams &&
    !isValidCopilotActivationRoute &&
    !isPerformanceDashboardRoute &&
    !isConnectConsentRoute
  );
}
